import { render, staticRenderFns } from "./prevencion-emergencias-actas.vue?vue&type=template&id=9d3a5c9a&scoped=true&"
import script from "./prevencion-emergencias-actas.vue?vue&type=script&lang=js&"
export * from "./prevencion-emergencias-actas.vue?vue&type=script&lang=js&"
import style0 from "./prevencion-emergencias-actas.vue?vue&type=style&index=0&id=9d3a5c9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3a5c9a",
  null
  
)

export default component.exports